import { call, put, takeLatest, select } from 'redux-saga/effects';
import * as types from '../constants/actionTypes';
import { getNotices } from '../api/portalApi';
import { forgotPassword, resetPassword, changePassword, changeUserName, forgotUserName, changeEmail } from '../api/accountApi';
import { logAPI } from "../api/andyliticsApi";

export default function* headerSaga() {
    try {
        const notices = yield call(getNotices);
        if (notices) {
            yield put({ type: types.NOTICES_NON_LOGGED_IN, notices: notices });
        }
    }
    catch (getNoticesError) {
        console.error(getNoticesError);
    }
    yield takeLatest([types.LOGOUT], handleAction);
    yield takeLatest([types.NOTICES_NON_LOGGED_IN_HIDE], handleAction);
    yield takeLatest([types.NOTICES_LOGGED_IN_HIDE], handleAction);
    yield takeLatest([types.USER_AUTHENTICATE_SUCCESS], handleAction);
    yield takeLatest([types.CHANGE_USERNAME], handleAction);
    yield takeLatest([types.CHANGE_PASSWORD], handleAction);
    yield takeLatest([types.FORGOT_PASSWORD_START], handleAction);
    yield takeLatest([types.RESET_PASSWORD_START], handleAction);
    yield takeLatest([types.FORGOT_USERNAME_START], handleAction);
    yield takeLatest([types.CHANGE_EMAIL_START], handleAction);
}

function* handleAction(data) {
    const domainData = yield select((state) => state.domain);

    switch (data.type) {
        //case types.USER_AUTHENTICATE_SUCCESS:
        //case types.SWITCH_USER:
        //    //set cookie and set property for my chart proxyid..... jball
        //    debugger;
        //    yield put({ type: types.LOAD_DASHBOARD_START });
        //    break;
        case types.NOTICES_NON_LOGGED_IN_HIDE:
        case types.NOTICES_LOGGED_IN_HIDE:
            data.notices.forEach(notice => localStorage.setItem('notice_' + notice.id, 'true'));
            break;

        case types.CHANGE_USERNAME:
            let start = new Date();
            let request = { oldUserName: data.OldUserName, newUserName: data.NewUserName };
            try {
                //debugger;
                const response = yield call(changeUserName, domainData.t, data.OldUserName, data.NewUserName);
                //debugger;
                if (response === "OK") {
                    logAPI("MBHWeb.Saga.Account.ChangeUserName", start, null);
                    yield put({ type: types.CHANGE_USERNAME_SUCCESS, userNameUpdateResponse: response, isWaiting: false });
                    yield put({ type: types.REFRESH_TOKEN });
                    if (data.successCallback) {
                        data.successCallback();
                    }
                }
                else {
                    logAPI("MBHWeb.Saga.Account.ChangeUserName.Failure", start, null, response);
                    yield put({ type: types.CHANGE_USERNAME_FAILURE, userNameUpdateResponse: response, apiErrorMessage: response, isWaiting: false });
                    if (data.failureCallback) {
                        data.failureCallback();
                    }
                }
            }
            catch (changeUserNameError) {
                console.error(changeUserNameError);
                logAPI("MBHWeb.Saga.Account.ChangeUserName.Failure", start, null, changeUserNameError);
                if (changeUserNameError && changeUserNameError.status && changeUserNameError.status === 404) {
                    const errorMessage = yield call(getErrorMessage, changeUserNameError);
                    yield put({ type: types.CHANGE_USERNAME_FAILURE, userNameError: changeUserNameError.statusText, apiErrorMessage: errorMessage, isWaiting: false });
                }
                else {
                    yield put({ type: types.CHANGE_USERNAME_FAILURE, userNameError: changeUserNameError.statusText, apiErrorMessage: null, isWaiting: false });
                }
                if (data.failureCallback) {
                    data.failureCallback();
                }
            }
            break;

        case types.CHANGE_PASSWORD:
            start = new Date();
            request = { email: data.Email }; // not logging password to protect user's privacy
            try {
                //debugger;
                const response = yield call(changePassword, domainData.t, data.Email, data.OldPassword, data.NewPassword, data.ConfirmPassword);
                //debugger;
                if (response === "OK") {
                    logAPI("MBHWeb.Saga.Account.ChangePassword", start, null);
                    yield put({ type: types.CHANGE_PASSWORD_SUCCESS, passwordUpdateResponse: response, isWaiting: false });
                    if (data.successCallback) {
                        data.successCallback();
                    }
                }
                else {
                    logAPI("MBHWeb.Saga.Account.ChangePassword.Failure", start, null, response);
                    yield put({ type: types.CHANGE_PASSWORD_FAILURE, passwordError: response, apiErrorMessage: response, isWaiting: false });
                    if (data.failureCallback) {
                        data.failureCallback();
                    }
                }
            }
            catch (changePasswordError) {
                console.error(changePasswordError);
                logAPI("MBHWeb.Saga.Account.ChangePassword.Failure", start, null, changePasswordError);
                if (changePasswordError && changePasswordError.status && (changePasswordError.status === 404 || changePasswordError.status === 400)) {
                    const errorMessage = yield call(getErrorMessage, changePasswordError);
                    yield put({ type: types.CHANGE_PASSWORD_FAILURE, passwordError: changePasswordError.statusText, apiErrorMessage: errorMessage, isWaiting: false });
                }
                else {
                    yield put({ type: types.CHANGE_PASSWORD_FAILURE, passwordError: changePasswordError.statusText, apiErrorMessage: null, isWaiting: false });
                }
                if (data.failureCallback) {
                    data.failureCallback();
                }
            }
            break;

        case types.FORGOT_PASSWORD_START:
            start = new Date();
            request = { userName: data.UserName, dob: data.DOB, zip: data.ZipCode };
            try {
                const response = yield call(forgotPassword, null, data.UserName, data.DOB, data.ZipCode);
                if (response.isSuccessful) {
                    logAPI("MBHWeb.Saga.Account.ForgotPassword", start, null);
                    yield put({
                        type: types.FORGOT_PASSWORD_SUCCESS,
                        success: { ...response, message: "You will receive an email that contains instructions on how to reset your password." }
                    });
                }
                else {
                    logAPI("MBHWeb.Saga.Account.ForgotPassword.Failure", start, null, response);
                    yield put({ type: types.FORGOT_PASSWORD_FAILURE, failure: response });
                }
            }
            catch (forgotPasswordError) {
                console.error(forgotPasswordError);
                logAPI("MBHWeb.Saga.Account.ForgotPassword.Failure", start, null, forgotPasswordError);
                const failure = !forgotPasswordError || !forgotPasswordError.statusText
                    ? { message: 'Sorry, we are unable to process your request. Please try again later.' }
                    : { ...failure, message: forgotPasswordError.statusText };
                yield put({ type: types.FORGOT_PASSWORD_FAILURE, failure });
            }
            break;

        case types.RESET_PASSWORD_START:
            start = new Date();
            try {
                const response = yield call(resetPassword, data.token, data.userId, data.password);
                if (response.isSuccessful) {
                    logAPI("MBHWeb.Saga.Account.ResetPassword", start, null);
                    yield put({ type: types.RESET_PASSWORD_SUCCESS, success: response });
                }
                else {
                    logAPI("MBHWeb.Saga.Account.ResetPassword.Failure", start, null, response);
                    yield put({ type: types.RESET_PASSWORD_FAILURE, failure: response });
                }
            }
            catch (resetPasswordError) {
                console.error(resetPasswordError);
                logAPI("MBHWeb.Saga.Account.ResetPassword.Failure", start, null, resetPasswordError);
                const failure = !resetPasswordError ? { message: 'Sorry, we are unable to process your request. Please try again later.' } : resetPasswordError.message ? resetPasswordError
                    : { ...resetPassword, message: resetPasswordError.statusText ? resetPassword.statusText : '' };
                yield put({ type: types.RESET_PASSWORD_FAILURE, failure });
            }
            break;

        case types.FORGOT_USERNAME_START:
            start = new Date();
            request = { email: data.Email, dob: data.DOB, firstName: data.FirstName, lastName: data.LastName, zip: data.ZipCode };
            try {
                let oResult = yield call(forgotUserName, null, data.Email, data.DOB, data.FirstName, data.LastName, data.ZipCode, true);
                if (oResult.isSuccessful) {
                    logAPI("MBHWeb.Saga.Account.ForgotUserName", start, null);
                    yield put({ type: types.FORGOT_USERNAME_SUCCESS, forgotUserNameSuccessMessage: "You will receive an email that contains your username." });
                }
                else {
                    logAPI("MBHWeb.Saga.Account.ForgotUserName.Failure", start, null, oResult);
                    yield put({ type: types.FORGOT_USERNAME_FAILURE, forgotUserNameFailureMessage: "Failed to process your request. " + oResult.message });
                }
            }
            catch (exception) {
                console.error(exception);
                logAPI("MBHWeb.Saga.Account.ForgotUserName.Failure", start, null, exception);
                if (exception && exception.status && exception.status === 404) {
                    yield put({ type: types.FORGOT_USERNAME_FAILURE, forgotUserNameFailureMessage: "Account not found. For technical assistance, please call the MyBSWHealth Technical Help Desk at 855-691-0180" });
                }
                else {
                    yield put({ type: types.FORGOT_USERNAME_FAILURE, forgotUserNameFailureMessage: exception && exception.statusText ? exception.statusText : "Failed to process." });
                }
            }
            break;

        case types.CHANGE_EMAIL_START:
            start = new Date();
            request = { userName: data.UserName, newEmail: data.NewEmail, confirmEmail: data.ConfirmEmail };
            try {
                const result = yield call(changeEmail, domainData.t, data.Username, data.NewEmail, data.ConfirmEmail);
                if (result === "OK") {
                    logAPI("MBHWeb.Saga.Account.ChangeEmail", start, null);
                    yield put({ type: types.CHANGE_EMAIL_SUCCESS, changeEmailSuccessMessage: "Your email has been updated.", changeEmailFailureMessage: false });
                    yield put({ type: types.REFRESH_TOKEN });
                }
                else {
                    logAPI("MBHWeb.Saga.Account.ChangeEmail.Failure", start, null, result);
                    yield put({ type: types.CHANGE_EMAIL_FAILURE, changeEmailFailureMessage: result.Message, changeEmailSuccessMessage: false });
                }
            }
            catch (changeEmailError) {
                console.error(changeEmailError);
                let errorText = null;
                if (changeEmailError && changeEmailError.status && changeEmailError.status === 400) {
                    const errorMessage = yield call(getErrorMessage, changeEmailError);
                    errorText = errorMessage;
                    yield put({ type: types.CHANGE_EMAIL_FAILURE, changeEmailErrorText: null, changeEmailFailureMessage: errorMessage, changeEmailSuccessMessage: false });
                }
                else if (changeEmailError && changeEmailError.status && changeEmailError.status === 404) {
                    errorText = 'None entered';
                    yield put({ type: types.CHANGE_EMAIL_FAILURE, changeEmailErrorText: errorText, changeEmailFailureMessage: null, changeEmailSuccessMessage: false });
                }
                else {
                    errorText = 'We are unable to display your email.';
                    yield put({ type: types.CHANGE_EMAIL_FAILURE, changeEmailErrorText: errorText, changeEmailSuccessMessage: false });
                }

                logAPI("MBHWeb.Saga.Account.ChangeEmail.Failure", start, null, errorText);
            }
            break;
    }
}

function getErrorMessage(changeUserNameError) {
    return changeUserNameError.json().then(data => {

        return data.Message;
    });
}